import { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: grid;
  overflow: hidden;

  ${({ theme }) => css`
    column-gap: ${theme.padding.biggest};
    margin-top: ${theme.padding.biggest};
  `}
`;

interface Props {
  templateColumns: string;
}

export const GridContainer = ({
  children,
  templateColumns,
}: PropsWithChildren<Props>) => {
  return (
    <Container style={{ gridTemplateColumns: templateColumns }}>
      {children}
    </Container>
  );
};
